import { ElementController, getData } from 'js-common';

const COUNTER_DURATION = 400;

/**
 * Controller for key figures block, creating animated counters.
 *
 * @extends ElementController
 */
export default class KeyFigure extends ElementController {
  static id = 'KeyFigure';

  /**
   * DOM loaded.
   */
  init() {
    this.keyFigureItems = this.selectAll('key-figure-item');

    this.observer = new IntersectionObserver(this.observerCallback, {
      root: null,
      rootMargin: '0px',
      // Visiblity of the root element is more than 50%.
      threshold: 0.5,
    });

    this.observer.observe(this.root);
  }

  /**
   * Observer callback function. The callback function is executed when observer
   * is registered therefore check if entry `isIntersecting` before starting the
   *  animation.
   *
   * @param {object} entries
   */
  observerCallback = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.observer.unobserve(this.root);
        this.startAnimation();
      }
    });
  };

  /**
   * Retrive counter data and start the counter for each item.
   */
  startAnimation = () => {
    this.keyFigureItems.forEach((item) => {
      this.startCounter(
        this.selectSingle(item, 'key-figure-number'),
        getData(item, 'key-figure-number'),
      );
    });
  };

  /**
   * Update the counter with the increment number for each item.
   *
   * @param {Element} counter
   * @param {number} targetNumber
   */
  startCounter(counter, targetNumber) {
    const updateCount = () => {
      const count = parseInt(counter.textContent, 10);

      // Only animate counter if user not has reduced-motion turned on.
      const hasReducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)',
      );

      if (count < targetNumber && !hasReducedMotion.matches) {
        const increment = Math.ceil(targetNumber / COUNTER_DURATION);
        counter.textContent = count + increment;
        setTimeout(updateCount, 1);
      } else {
        counter.textContent = targetNumber;
      }
    };
    updateCount();
  }
}
